import { useQuery as defaultUseQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

import { ApolloInjection, PaymentSourceQuery } from '@zapier/upsells/src/types';

type Props = {
  accountId: number | undefined;
  skip?: boolean;
} & ApolloInjection;

export const paymentSourceQuery = gql`
  query upsells_paymentSourceQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      paymentSources {
        id
      }
    }
  }
`;

export const usePaymentSource = ({
  accountId,
  skip = false,
  useQuery,
}: Props) => {
  const _useQuery = useQuery || defaultUseQuery;
  const { data, error, loading: isLoading } = _useQuery<PaymentSourceQuery>(
    paymentSourceQuery,
    {
      skip: skip || !accountId,
      variables: {
        accountId,
      },
    }
  );

  const paymentSources = data?.account?.paymentSources ?? [];
  const primarySource = paymentSources[0];

  return {
    error: error?.message,
    isLoading,
    isPaymentMethodProvided: Boolean(primarySource),
  };
};
